import { ChangeDetectionStrategy, Component, inject, signal, WritableSignal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from "@angular/material/core";
import { MatCardModule } from '@angular/material/card';
import { IDiagnosisAI, SophiaAgentAIService } from '../../../../services/sophia-agent-ai.service';
import { FichaClinicaStore } from '../../../../../shared/stores/ficha-clinica/ficha-clinica.store';
import { lastValueFrom } from 'rxjs';
import { MatProgressBar } from "@angular/material/progress-bar";

@Component({
  selector: 'sophia-agent-ai-diagnosis-modal',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatButtonModule, MatRippleModule, MatCardModule, MatProgressBar],
  templateUrl: './diagnosis-ai-modal.component.html',
  styleUrl: './diagnosis-ai-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SophiaAgentAIDiagnosisModalComponent {
  private readonly sophAIService = inject(SophiaAgentAIService);
  private readonly fichaClinicaStore = inject(FichaClinicaStore);

  protected readonly loading: WritableSignal<boolean> = signal(false);
  protected readonly hasError: WritableSignal<boolean> = signal(false);
  protected readonly diagnosis: WritableSignal<IDiagnosisAI | null> = signal(null);

  ngOnInit() {
    const { idAgendamiento, idPaciente } = this.fichaClinicaStore.values;

    const diagnosis$ = this.sophAIService.getDiagnosis(idAgendamiento!, idPaciente!);

    this.loading.set(true);

    setTimeout(() => {
      lastValueFrom(diagnosis$, { defaultValue: null }).then(response => {
        if (response) {
          this.diagnosis.set(response);
        }
      }).catch(error => {
        console.error({ error });
        this.hasError.set(true);
      }).finally(() => {
        this.loading.set(false);
      });
    }, 1000);
  }
}
